
import {
  Component, Prop, Vue, Provide,
} from 'nuxt-property-decorator'
import { Section, RichTextElement } from 'fsxa-api'
import { TContentProjection } from '../shared/general/types/TContentProjection'
import { globalLabelAsString } from '../shared/general/services/StoreService'
import PageNotTranslated from './fsxa/PageNotTranslated.vue'

@Component({
  name: 'ContentProjection',
  components: {
    PageNotTranslated,
    FSXARenderContentElement: async () => (await import('fsxa-pattern-library')).FSXARenderContentElement,
    BaseGridLayout: () => import('./layouts/BaseGridLayout.vue'),
    BaseHeadline: () => import('./base/BaseHeadline.vue'),
    SeparationLine: () => import('./SeparationLine.vue'),
    EventHeader: () => import('./EventHeader.vue'),
    BaseButton: () => import('./base/BaseButton.vue'),
    GlobalLabelWrapper: () => import('./GlobalLabelWrapper.vue'),
  },
})
export default class ContentProjection extends Vue {
  @Prop({ required: true }) type! : TContentProjection

  @Prop({ default: false }) showInThisLanguage! : boolean

  @Prop() headline ?: string

  @Prop() location ?: string

  @Prop() date ?: string

  @Prop() author ?: string

  @Prop() overline ?: string

  @Prop({ default: () => [] }) pageContent! : Section[]

  @Prop() overviewPageLabel ?: string

  @Prop() overviewPageLink ?: string

  @Prop({ default: () => [] }) tags! : string[]

  @Provide('separationLineUsedInContentProjection') separationLineUsedInContentProjection : boolean = true

  @Provide('carouselUsedInContentProjection') carouselUsedInContentProjection : boolean = true

  @Provide('infoboxUsedInContentProjection') infoboxUsedInContentProjection : boolean = true

  private get marginTopContent () : string {
    return this.type === 'event' ? '!mt-4' : '!mt-2'
  }

  private get authorLabel () : string | RichTextElement[] {
    return globalLabelAsString('author_label')
  }
}
